<template>
  <ZNotification :open="open" :color="color" @close="onClose">
    <template #default>
      <div class="global-notification__message" :style="messageStyle">
        {{ message }}
      </div>
    </template>
    <template v-if="IconComponent" #customIcon>
      <component :is="IconComponent" v-bind="SVGProps" />
    </template>
  </ZNotification>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from 'vue';
import { useSVG } from '@zoomcatalog/core-ui';
import { ZNotification } from '@zoomcatalog/design-system';
import { useStore } from 'vuex';
import { RootStore, useCommit } from '@/store/rootStore';

export default defineComponent({
  name: 'GlobalNotification',
  components: {
    ZNotification,
  },
  setup() {
    const store = useStore<RootStore>();
    const commit = useCommit();

    const { SVGProps } = useSVG({
      customStyles: { width: '20px', height: '20px' },
    });

    const IconComponent = computed(
      () => store.state.notification.customIcon || null
    );

    return {
      IconComponent,
      SVGProps,
      ...toRefs(store.state.notification),
      onClose: () => commit({ type: 'notification/closeNotification' }),
    };
  },
});
</script>
<style lang="scss" scoped>
.global-notification {
  &__message {
    @apply flex;
  }
}
</style>
